<template>
    <div v-if="homeData" class="homeCatalog">
        <div class="homeCatalog__content">
            <div class="homeCatalog__items row">
                <div class="homeCatalog__items-left col">
                    <ul>
                        <li v-for="(item,idx) in homeData.homePageCategories" :key="idx">
                            <img v-if="item.logo" :src="item.logo" alt="">
                            <router-link class="f-18" :to="{name: 'CategoryBySlug',params: {slug: item.slug}}">
                            <span>{{ item.label }}
                                <p>({{ item.count ? item.count : 0 }}-объяв.)</p>
                            </span>
                            </router-link>
                        </li>
                    </ul>
                </div>
                <div class="homeCatalog__items-right col">
                    <img src="@/assets/images/svg/Kazakhstan.svg" alt="">
                    <button class="f-18">Все объявления по всему Казахстану</button>
                </div>                
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['homeData'],
    data: () => ({
        links: [
            {
                name: 'Верблюды',
                icon: require("@/assets/images/svg/cat1.svg"),
                desc: '',
                count: 8
            },
            {
                name: 'Лошади ',
                icon: require("@/assets/images/svg/cat2.svg"),
                desc: '',
                count: 3
            },
            {
                name: 'Крупный рогатый скот',
                icon: require("@/assets/images/svg/cat3.svg"),
                desc: '',
                count: 7
            },{
                name: 'Мелкий рогатый скот',
                icon: require("@/assets/images/svg/cat4.svg"),
                desc: '',
                count: 8
            },{
                name: 'Живность',
                icon: require("@/assets/images/svg/cat5.svg"),
                desc: '',
                count: 8
            },{
                name: 'Товары',
                icon: require("@/assets/images/svg/cat6.svg"),
                desc: '',
                count: 32
            },{
                name: 'Работы',
                icon: require("@/assets/images/svg/cat7.svg"),
                desc: '',
                count: 8
            },{
                name: 'Услуги',
                icon: require("@/assets/images/svg/cat8.svg"),
                desc: '',
                count: 8
            }
        ]
    })

}
</script>

<style>

</style>